import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { stageChange, clearChange } from '../actions/StagingActions';
import { PHONE } from '../constants/StagingDataKeys';
import { isUserImpersonated } from '../selectors/AuthSelector';
import { isRestrictedImpersonatee } from '../selectors/IsRestrictedImpersonateeSelector';
import { getCurrentUserPhoneNumber } from '../selectors/AttributesSelector';
import { getFetchAttributesRequestStatus } from '../selectors/RequestStatusSelector';
import PhoneNumberEditor from '../components/PhoneNumberEditor';
import { anyRequestsFailed, allFinished } from '../utils/requestUtils';
import { MultiColumn, MultiColumnGroup, MultiColumnItem } from 'foundations-components/transitional/components/MultiColumn';
import { jsx as _jsx } from "react/jsx-runtime";
class PhoneNumberContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invalidPhoneNumber: false
    };
    this.handleStagedPhoneNumberChange = this.handleStagedPhoneNumberChange.bind(this);
  }
  handleStagedPhoneNumberChange(phoneData) {
    const {
      phoneNumber
    } = this.props;
    if (phoneData.phoneNumber !== phoneNumber) {
      this.props.stageChange(PHONE, phoneData.phoneNumber);
    } else {
      this.props.clearChange(PHONE);
    }
  }
  render() {
    const {
      fetchAttributesRequestStatus,
      stagedPhoneNumber,
      phoneNumber,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsx(MultiColumn, {
      flush: true,
      children: /*#__PURE__*/_jsx(MultiColumnGroup, {
        children: /*#__PURE__*/_jsx(MultiColumnItem, {
          children: /*#__PURE__*/_jsx(PhoneNumberEditor, {
            failed: anyRequestsFailed(fetchAttributesRequestStatus),
            loading: !allFinished(fetchAttributesRequestStatus),
            stagedPhoneNumber: stagedPhoneNumber || phoneNumber,
            onStagedPhoneNumberChange: this.handleStagedPhoneNumberChange,
            readOnly: readOnly
          })
        })
      })
    });
  }
}
PhoneNumberContainer.propTypes = {
  phoneNumber: PropTypes.string,
  stageChange: PropTypes.func.isRequired,
  stagedPhoneNumber: PropTypes.string,
  clearChange: PropTypes.func.isRequired,
  fetchAttributesRequestStatus: PropTypes.string.isRequired,
  readOnly: PropTypes.bool.isRequired
};
const mapStateToProps = state => {
  return {
    phoneNumber: getCurrentUserPhoneNumber(state),
    stagedPhoneNumber: state.stagedChanges.get(PHONE),
    fetchAttributesRequestStatus: getFetchAttributesRequestStatus(state),
    readOnly: isUserImpersonated(state) && !isRestrictedImpersonatee(state)
  };
};
export default connect(mapStateToProps, {
  stageChange,
  clearChange
})(PhoneNumberContainer);